import { Section } from "@hydrologiq/shared/providers/CopyProvider"

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: "dashboard-390313",
  storageBucket: "dashboard-390313.appspot.com",
  messagingSenderId: "159313331981",
  appId: "1:159313331981:web:72dd23465816fa3ae71244",
  measurementId: "G-PYDN2D45FP",
}

export const mapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY
export const graphqlEndpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT ?? "dashboard"
export const graphqlUriLegacy = `${import.meta.env.VITE_GRAPHQL_HOST}/api/${graphqlEndpoint}/__graphql`

export const restEndpoint = import.meta.env.VITE_CORE_REST_ENDPOINT
export const graphqlUri = `${restEndpoint}/graphql`
export const betterAuthUrl = import.meta.env.VITE_BETTER_AUTH_URL ?? "http://localhost:3000"

export const section = Section.ALERTS